const ITEMS = [
  "IOGAMA",
  "Eccellenza calzaturiera a Napoli",
  "Distribuzione B2B europea",
  "Solo ingrosso · Wrangler · Freddy · Nautica",
  "Made in Italy",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="overflow-hidden border-y border-black/10 bg-paper py-5"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="marquee-track items-center gap-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10 pr-10">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10 whitespace-nowrap">
                <span className="font-mono text-xs uppercase tracking-[0.3em] text-ink/70">{item}</span>
                <span className="h-1.5 w-1.5 rotate-45 bg-terracotta" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
